import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vconsole from 'vconsole'
// 为了能够覆盖默认的 less 变量，这里要把css 的后缀名改为 less
import 'vant/lib/index.less'
import VueLoadmore from 'vuejs-loadmore';
import {
  Button, CheckboxGroup, RadioGroup, Dialog, Notify, Popup, Icon as VantIcon, Loading, Toast,
  List, Tabs, Tab, Switch, PullRefresh, TreeSelect, DatetimePicker, Picker,
  Search, DropdownMenu, DropdownItem, Swipe, SwipeItem, SwipeCell, Field, Checkbox,
  Overlay, Sticky, Form, Cell, CellGroup, ActionSheet, Badge, Rate, Skeleton, Tag, Lazyload,
  Image as VanImage, Divider, NavBar,
} from 'vant';

window.MAIN_DOMAIN  = location.hostname.indexOf('appbeta') > -1 ? 'appbeta.tuchong.com' : 'tuchong.com';
const MAIN_DOMAIN = window.MAIN_DOMAIN;

import './util/axios';
Vue.use(NavBar);
Vue.use(Button);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(Popup);
Vue.use(VantIcon);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(List);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Switch);
Vue.use(PullRefresh);
Vue.use(TreeSelect);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Search);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(SwipeCell);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Overlay);
Vue.use(Sticky);
Vue.use(Form);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(ActionSheet);
Vue.use(Badge);
Vue.use(Rate);
Vue.use(Skeleton);
Vue.use(Tag);
Vue.use(Lazyload);
Vue.use(VueLoadmore);
Vue.use(VanImage);
Vue.use(Divider);

Vue.mixin({
  data: () => {
    return {
      MAIN_DOMAIN
    }
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (process.env.VUE_APP_BUILD_TYPE == 'debug') {
  // 测试和开发打开，生产不能打开
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}